import { useContext, useMemo } from "react";

import { useGetPolls } from "../api/polls";
import PollsTable from "../components/Polls/PollsTable";
import { AuthContext } from "../services/context";
import { getCurrentWorkspace } from "../services/userConfig";
import { useParams } from "react-router-dom";
import { useSetActionButtons } from "../services/ActionButtonsContext";
import { IconPlus } from "@tabler/icons-react";

// Drag and drop reordering and follow up chaining need the whole session's
// polls in memory, so the list is loaded in one page instead of paginated.
const POLLS_LIMIT = 500;

function Polls() {
  const actions = useMemo(
    () => [
      {
        label: "Create",
        icon: <IconPlus />,
        navigate: "./polls/create",
      },
    ],
    []
  );

  useSetActionButtons(actions);

  const { user } = useContext(AuthContext);
  const currentWorkspace = getCurrentWorkspace(user);
  const { sessionId } = useParams();

  const { data, isPending: isLoading } = useGetPolls({
    page: 1,
    limit: POLLS_LIMIT,
    workspaceId: currentWorkspace.id,
    eventId: currentWorkspace.eventId,
    sessionId,
  });

  return <PollsTable data={data} isLoading={isLoading} />;
}

export default Polls;
